export default __webpack_public_path__ + "static/media/HONDA.ada14644.png";